var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuExitIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#435382",
    stroke: "#435382",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00048 2.99805H19.0005C20.1055 2.99805 21.0005 3.89404 21.0005 4.99805V8.99805H19.0005V4.99805H5.00048V18.998H19.0005V14.998H21.0005V18.998C21.0005 20.1021 20.1055 20.998 19.0005 20.998H5.00048C3.89648 20.998 3.00048 20.1021 3.00048 18.998V4.99805C3.00048 3.89404 3.89648 2.99805 5.00048 2.99805ZM13.9155 15.584L12.5005 16.998L7.50048 11.998L12.5005 6.99805L13.9155 8.41205L11.3295 10.998H21.0005V12.998H11.3295L13.9155 15.584Z",
    fill: "current",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuExitIcon);
export default __webpack_public_path__ + "static/media/menu-exit-icon.e45024fbd35a1327e07898da8dca9516.svg";
export { ForwardRef as ReactComponent };